// react library imports
import { SquaresFour, XCircle } from 'phosphor-react';
import { NavLink } from 'react-router-dom';
import { useState, useEffect } from 'react';

// style imports
import './Topbar.css';

// navigation list
const navigationList = [
    {
        id: 1,
        path: "/preschool",
        name: "Preschools"
    },
    {
        id: 2,
        path: "/teacher",
        name: "Teacher"
    },
    {
        id: 3,
        path: "/parent",
        name: "Parent"
    },
    {
        id: 4,
        path: "/resource",
        name: "Resources"
    },
    {
        id: 5,
        path: "/login",
        name: "Login"
    },
]

const Topbar = () => {
    // set state
    const [showAdd, setShowAdd] = useState(true)
    const [show, setShow] = useState(false)
    const [daysLeft, setDaysLeft] = useState(null)

    useEffect(() => {
        const today = new Date(); // Current date
        const targetDate = new Date("2025-02-20"); // Target date
        const timeDifference = targetDate - today; // Difference in milliseconds
        const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days
        setDaysLeft(daysDifference)

    }, [daysLeft])
    return (
        <div className={`top_bar_navigation ${showAdd ? "top_bg_blue" : "top_bg_transparent"}`}>
            <nav className='mues_row_space_between top_bar_container padding_container'>
                <NavLink to="/" className='mues_logo'>
                    <img src="https://mues-solution.s3.ap-south-1.amazonaws.com/svg/mues-tech.svg"
                        alt="mues_logo" loading='lazy' />
                </NavLink>
                <section className='mues_grey_I top_bar_icon_container'
                    onClick={() => setShow(!show)}>
                    <SquaresFour className='top_bar_icon' />
                </section>
                <ul className='top_bar_list_container mues_row_flex'>
                    {navigationList.map(item => (
                        <NavLink to={item.path} key={item.id}>
                            <li>{item.name}</li>
                        </NavLink>
                    ))}
                    <NavLink to={'/register'} className='sign_up_button small_btn btn'>Join us</NavLink>
                </ul>
            </nav>
            {showAdd && <div className='top_bar_last_container mues_blue_background mues_row_space_between'>
                <h6 className='mues_white mues_one_line_clamp
                mues_font_weight_600 mues_text_align_center'>Empowering Education, Enabling Growth.</h6>
                <XCircle className='mues_white top_bar_last_icon mues_pointer'
                    weight='fill' onClick={() => setShowAdd(false)} />
            </div>}
            {show && <div className='top_bar_menu_item_container'>
                {navigationList.map(item => (
                    <NavLink to={item.path} key={item.id}>
                        <li onClick={() => setShow(!show)}>{item.name}</li>
                    </NavLink>
                ))}
                <NavLink to={'/register'} className='sign_up_button small_btn btn'><span>Join us</span></NavLink>
            </div>}
        </div>
    )
}

export default Topbar